module.exports = __webpack_public_path__ + "static/media/call_welcome_no_participants.7a59b01.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/sounds/call_welcome_no_participants.mp3
// module id = 403
// module chunks = 1